import { render, staticRenderFns } from "./bgTop.vue?vue&type=template&id=dc7a902a&scoped=true&"
var script = {}
import style0 from "./bgTop.vue?vue&type=style&index=0&id=dc7a902a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7a902a",
  null
  
)

export default component.exports